import { Link } from "react-router-dom";
import { MessageCircle, Phone } from "lucide-react";
import { SITE } from "../../lib/site";

export default function StickyCTAs() {
  return (
    <div className="fixed bottom-0 left-0 w-full z-40 md:hidden">
      <div className="grid grid-cols-2 border-t border-white/10">
        <a href={SITE.whatsapp} target="_blank" rel="noreferrer" data-testid="sticky-whatsapp"
          className="flex items-center justify-center gap-2 py-3.5 bg-[#0D0D12] text-white font-mono2 text-xs uppercase tracking-[0.1em] border-r border-white/10">
          <MessageCircle size={16} className="text-holo-cyan" /> WhatsApp
        </a>
        <Link to="/contact" data-testid="sticky-quote"
          className="flex items-center justify-center gap-2 py-3.5 bg-white text-black font-mono2 text-xs uppercase tracking-[0.1em] font-bold">
          <Phone size={16} /> Get Quote
        </Link>
      </div>
    </div>
  );
}

export function FloatingCTAs() {
  return (
    <div className="hidden md:flex fixed bottom-8 right-8 z-40 flex-col gap-3">
      <a href={SITE.whatsapp} target="_blank" rel="noreferrer" data-testid="float-whatsapp"
        className="w-14 h-14 flex items-center justify-center bg-[#0D0D12] border border-white/10 hover:border-holo-cyan transition-colors group" aria-label="WhatsApp">
        <MessageCircle size={22} className="text-holo-cyan group-hover:scale-110 transition-transform" />
      </a>
      <a href={`tel:${SITE.phoneRaw}`} data-testid="float-phone"
        className="w-14 h-14 flex items-center justify-center bg-[#0D0D12] border border-white/10 hover:border-holo-cyan transition-colors group" aria-label="Call">
        <Phone size={20} className="text-white group-hover:scale-110 transition-transform" />
      </a>
    </div>
  );
}
